import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import useLocations from '@/common/hooks/useLocations/useLocations'

import { getLocationError, getLocationErrorMessage } from './helpers'

const LocationsSelector = ({ value, onChange, errors, label }) => {
  const { info } = useContext(AppContext)
  const { t } = useTranslation()
  const { locations } = useLocations({ storeId: info?.selectedStore?.id })

  const handleChange = event => {
    const locationId = event.target.value
    const location = locations.find(l => l.id === locationId)
    onChange(location)
  }

  return (
    <div id={getLocationError(errors)?.type}>
      <ComboBox
        value={value}
        handleChange={handleChange}
        label={label || t('Ubicación de destino')}
        menuItems={locations?.map(l => ({ label: `${l.internal_id} | ${l.internal_name}`, value: l.id })) || []}
        helperText={t(getLocationErrorMessage(errors, value))}
        error={getLocationError(errors)}
        fullWidth
      />
    </div>
  )
}

export default LocationsSelector
